import NotificationInfoWindowContent from './NotificationInfoWindowContent';

export default NotificationInfoWindowContent;